
































































































































import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { BankModule, NavModule, ProfileModule } from "@/store";
import { MediaQuery } from '@/MediaQuery';
import {
  mdbAlert,
  mdbBtn,
  mdbCol,
  mdbContainer,
  mdbInput,
  mdbRow
} from "mdbvue";
import { RouterUtils } from '@/router/RouterUtils'
import { ParticipantUpdateRequest } from "@fgl/funfangle-sdk/dist/rest/profile";

// Define the props by using Vue's canonical way.
const SnackbarLimitProps = Vue.extend({
  props: {
    personId: String
  },
  mixins: [RouterUtils]
});

@Component({
  components: {
    mdbAlert,
    mdbBtn,
    mdbCol,
    mdbContainer,
    mdbInput,
    mdbRow
  }
})
export default class SnackbarLimit extends SnackbarLimitProps {
  bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  MediaQuery = MediaQuery;

  activeSection: string = "#form";
  errorMessage: string | null = null;
  successMessage: string | null = null;
  snackbarLimit: number | null = 0;
  isProcessing: boolean = false;

  get isButtonDisabled() {
    if (
      this.snackbarLimit == null ||
      this.snackbarLimit <= 0 ||
      this.isProcessing
    ) {
      return true;
    }
    return false;
  }

  // @Watch("$route", { immediate: true, deep: true })
  // onRouteChange(newRoute: any, oldRoute: any): void {
  //   // console.log("deposits route", this.$route, oldVal, newVal);
  //   // if (newRoute.hash !== oldRoute.hash) {
  //   //   // something?
  //   // }
  // }
  /* *** method elements: mixins, methods *** */
  // methods: {
  //   ...mapActions("bank", ["updateSpendingLimit"]),
  //   ...mapMutations(["setPersonSpendingLimit"]),
  handleNextClick() {
    if (this.profileStore.organizationId == null) {
      this.errorMessage = 'No organization id';
      return;
    }
    // add route to stack
    this.navStore.pushBackbarStack(this.$route);
    // params
    const params = new ParticipantUpdateRequest(
      this.navStore.selectedUserId,
      this.profileStore.organizationId,
      this.profileStore.userId
    );
    params.dailySpendingLimit = Number(this.snackbarLimit || 0);
    // let params = {
    //   personId: this.navStore.selectedUserId,
    //   dailySpendingLimit: this.snackbarLimit
    // };
    // console.log(params);
    this.isProcessing = true;
    this.errorMessage = null;
    this.successMessage = null;
    // update spending limit
    this.bankStore.updateSpendingLimit(params)
      .then(() => {
        this.isProcessing = false;
        // console.log("res:", res);
        // this.setPersonSpendingLimit({
        //   personId: this.navStore.selectedUserId,
        //   amount: this.snackbarLimit
        // });
        this.profileStore.fetchAllDetails().catch();
        this.successMessage =
          "Limit set to " + this.$n(this.snackbarLimit || 0, "currency");
        this.activeSection = "#result";
        // alert(this.successMsg)
        // this.goBankAccountPage(this.navStore.selectedUserId)
      })
      .catch((err: Error) => {
        this.errorMessage = err.message;
        this.isProcessing = false;
        // console.log('Caught err:', err)
      });
  }
  closePage() {
    window.location.hash = "new-budget";
  }

  /* *** lifecycle elements: created, mounted *** */
  created() {}
  mounted() {
    // if (this.navStore.selectedUser == null) return 0;
    // this.snackbarLimit = this.navStore.selectedUser.dailySpendingLimit || 0;
    if (this.profileStore.userPairs !== undefined) {
      for (const pair of this.profileStore.userPairs) {
        if (pair.childId === this.$route.params.personId && pair.parentId === this.profileStore.userId && pair.child !== undefined) {
          this.snackbarLimit = pair.child.dailySpendingLimit || 0;
        }
      }
    }
  }
}
